import React from "react";
import { Link } from "react-router-dom";
import "../MenuLeftPhoneProvComercializadorLealtad/menuLeftPhoneLealtad.css";
//
import logo from "../../../Lealtad/assets/logo/logo2.png";
//
import { MdOutlineAttachMoney } from "react-icons/md";
import { FaUserAlt } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FaFileArchive } from "react-icons/fa";
import { FaDeleteLeft } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { LuClipboardList } from "react-icons/lu";
import { ImProfile } from "react-icons/im";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";

const MenuPhoneAdminLealtad = ({ viewSee }) => {
  const navigate = useNavigate();

  const changeviewprov = (e, page) => {
    e.preventDefault();
    viewSee(page);
  };

  const handleLogout = () => {
    Cookies.remove("token");
    Cookies.remove("adminType");
    sessionStorage.removeItem("Data");
    navigate("/");
  };

  return (
    <div className="boxphonemenucellealtad">
      <div>
        <div className="boxlogophonemenulealtad">
          <img src={logo} alt="logo" />
        </div>
        <div className="flexbuttonsphonelealtad">
          <div className="buttonsphonelealtad">
            <Link to="/portal-admin-proveedor-lealtad/todas-las-ventas">
              <p className="textcellealtad">
                <MdOutlineAttachMoney className="phoneiconlealtad" />
                Ventas
              </p>
            </Link>
          </div>
          <div className="buttonsphonelealtad">
            <Link to="/portal-admin-proveedor-lealtad/lista-comercializadores">
              <p className="textcellealtad">
                <FaUserCog className="phoneiconlealtad" />
                Comercializador
              </p>
            </Link>
          </div>
          <div className="buttonsphonelealtad">
            <Link to="/portal-admin-proveedor-lealtad/lista-proveedores">
              <div className="boxbuttonprovlealtad">
                <p className="letterbuttonprovlealtad">
                  <FaUserCog className="iconprovlealtad" />
                  Proveedores
                </p>
              </div>
            </Link>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Perfil")}
          >
            <p className="textcellealtad">
              <FaUserAlt className="phoneiconlealtad" />
              Perfil
            </p>
          </div>
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Excel")}
          >
            <p className="textcellealtad">
              <ImProfile className="phoneiconlealtad" />
              Alta Comercializadores
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "ExcelSales")}
          >
            <p className="textcellealtad">
              <FaFileArchive className="phoneiconlealtad" />
              Alta de ventas
            </p>
          </div>
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "ListProveedordescarga")}
          >
            <p className="textcellealtad">
              <LuClipboardList className="phoneiconlealtad" />
              Descargar ventas
            </p>
          </div>
        </div>
        <div className="flexbuttonsphonelealtad">
          <div
            className="buttonsphonelealtad"
            onClick={(e) => changeviewprov(e, "Contraseña")}
          >
            <p className="textcellealtad">
              <RiLockPasswordFill className="phoneiconlealtad" />
              Cambiar contraseña
            </p>
          </div>
          <div className="buttonsphonelealtad" onClick={handleLogout}>
            <p className="textcellealtad">
              <FaDeleteLeft className="phoneiconlealtad" />
              Salir
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPhoneAdminLealtad;